var SignInForm = Backbone.View.extend({
  template: 'modals.loginForm.signInForm',

  events: {
    'click #signInButton': 'signIn',
    'click .forgot-password-link': 'forgotPassword',
    'keydown .password-form': 'trySubmit',
    'keydown .email-form': 'trySubmit'
  },

  initialize: function() {
    this.hasRendered = false;
  },

  beforeRender: function() {

    if (this.hasRendered) {
      return false;
    }
    this.hasRendered = true;
    return true;
  },

  afterRender: function() {
    this.$el.modal({
      show: false
    });

    this.$email = this.$el.find('.email-form');
    this.$password = this.$el.find('.password-form');
    this.$message = this.$el.find('.message');
  },

  trySubmit: function(e) {
    if (e.keyCode == 13) {
      this.signIn();
    }
  },

  signIn: function() {
    var email = this.$email.val();
    var password = this.$password.val();

    //TODO:: some validation stuff
    bookedby.app.loginClient(email, password, _.bind(this.onLoginSuccess, this), _.bind(this.onLoginFail, this));
  },

  onLoginSuccess: function(data) {
    this.parent.$el.modal('hide');
    if(this.parent.callback) {
      this.parent.callback();
    }
  },

  onLoginFail: function(data) {
    //TODO:: better error display...
    if (data.success && !data.found) {
      //TODO:: login failed message
      alert('Login failed.');
    }
    if (!data.success) {
      if (data.userError) {
        alert(data.error);
      } else {
        alert('There was a problem processing your request. Please try again in a few minutes.');
      }
    }
  },

  forgotPassword: function() {
    this.parent.$el.modal('hide');
    bookedby.app.showRecoveryPassword();
  }
});

module.exports = SignInForm;